/**
 * Represents the steps involved in an instruction process.
 */
export enum AgentStep {
    DETAILS = 'Agent Details',
    DEFINITION = 'Agent Definition',
    API_SETTINGS = 'API Settings',
    SECURITY = 'Security',
    ADMIN = 'Admin',
}